export enum PortalEventContext {
  ENTERPRISE_OPTIONS = 'ENTERPRISE_OPTIONS',
  END_USER_RICH_PRESENCE = 'END_USER_RICH_PRESENCE',
  NOTIFICATION_UPDATE = 'NOTIFICATION_UPDATE',
}
